module.exports = __webpack_public_path__ + "img/img_upload.66284807.svg";